module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-link"
  }, [_c('a', {
    staticClass: "tool-item"
  }, [_c('i', {
    class: _vm.item.icon
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.href,
      "target": "_blank"
    },
    on: {
      "click": _vm.recordLead
    }
  }, [_vm._v(_vm._s(_vm.item.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e23a7ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PresenterLink.vue
// module id = 484
// module chunks = 0